interface Theme {
    mobileMenuBreakpoint: number;
    mobileTableBreakPoint: number;
    brandColor1: string;
    brandColor2: string;
}

export const lummeTheme: Theme = {
    mobileMenuBreakpoint: 1635,
    mobileTableBreakPoint: 1000,
    brandColor1: "#96008F",
    brandColor2: "#7FB722"
}